export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/selected-star-icon.png?8bf913ccef025d6fcaeb1f735c592616";